import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { Icon } from './icon.js';

var styles = {
raw: ".hcr-tag-1-6-0{display:inline-block;max-width:100%;height:30px;padding:0 12px;border:1px solid #73d700;border-radius:15px;outline:0;background:#fff;color:#73d700;font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:400;line-height:28px;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;vertical-align:middle}.hcr-tag--success-1-6-0{border:0;background:#73d700;color:#fff;line-height:30px}.hcr-tag--warning-1-6-0{border:0;background:#ffad00;color:#fff;line-height:30px}.hcr-tag--danger-1-6-0{border:0;background:#ff5700;color:#fff;line-height:30px}.hcr-tag-1-6-0:disabled,.hcr-tag--disabled-1-6-0{border:0;background:#c8c8c8;color:#fff;line-height:30px;cursor:not-allowed}button.hcr-tag-1-6-0{cursor:pointer}.hcr-tag__icon-1-6-0:first-child:before{margin-left:0}.hcr-tag__icon-1-6-0{margin-top:-2px}.hcr-tag__icon-1-6-0 svg{fill:#73d700}.hcr-tag--danger-1-6-0 .hcr-tag__icon-1-6-0 svg,.hcr-tag--disabled-1-6-0 .hcr-tag__icon-1-6-0 svg,.hcr-tag--success-1-6-0 .hcr-tag__icon-1-6-0 svg,.hcr-tag--warning-1-6-0 .hcr-tag__icon-1-6-0 svg{fill:#fff}",
map:{"hcr-tag":"hcr-tag-1-6-0","hcr-tag--success":"hcr-tag--success-1-6-0","hcr-tag--warning":"hcr-tag--warning-1-6-0","hcr-tag--danger":"hcr-tag--danger-1-6-0","hcr-tag--disabled":"hcr-tag--disabled-1-6-0","hcr-tag__icon":"hcr-tag__icon-1-6-0"}};

var bem = Bem('tag', styles);
var Tag = function Tag(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      disabled = _ref.disabled,
      Elem = _ref.Elem,
      extraClasses = _ref.extraClasses,
      InlineIcon = _ref.InlineIcon,
      rest = _objectWithoutProperties(_ref, ["appearance", "children", "disabled", "Elem", "extraClasses", "InlineIcon"]);

  return React.createElement(Elem, _extends({
    className: bem.b([appearance, {
      disabled: disabled
    }], extraClasses),
    disabled: disabled
  }, rest), InlineIcon ? React.createElement(Icon, {
    extraClasses: "".concat(bem.e('icon')),
    InlineIcon: InlineIcon
  }) : null, children);
};
Tag.displayName = 'Tag';
Tag.defaultProps = {
  appearance: null,
  Elem: 'div',
  extraClasses: '',
  disabled: false,
  InlineIcon: null
};
Tag.propTypes = {
  /** Type of list */
  appearance: PropTypes.oneOf([null, 'success', 'warning', 'danger', 'disabled']),

  /** Content of the tag */
  children: PropTypes.node.isRequired,

  /** Disabled to be used when displayed as button */
  disabled: PropTypes.bool,

  /** Define wrapping element */
  Elem: PropTypes.oneOf(['button', 'a', 'div']),

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Optional icon, needs to be an svg inline icon component */
  InlineIcon: PropTypes.func
};
var tag = Injecss(Tag, styles);

export { tag as Tag };
